function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.964 16.632v1.733a2.6 2.6 0 01-2.599 2.599H3.635a2.6 2.6 0 01-2.599-2.599v-1.733M11 1.036v15.497M4.659 7.377L11 1.036l6.341 6.341",
  stroke: "#000",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref);
}

export default SvgUpload;